import { IconType } from "react-icons";
import { GiMoneyStack } from "react-icons/gi";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";
import { FaCoins, FaMoneyBillTransfer } from "react-icons/fa6";
import { RiCoupon4Line } from "react-icons/ri";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import { PiBankLight } from "react-icons/pi";

type NavItemTypeWithoutChild = {
  label: string;
  moduleName: string;
  path: string;
  icon: IconType;
  children?: never;
};

type NavItemTypeWithChild = {
  label: string;
  moduleName: string;
  path?: never;
  icon: IconType;
  children?: {
    label: string;
    moduleName: string;
    path: string;
    icon: IconType;
  }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const financeNavigation: NavItemType[] = [
 
  {
    label: "Expense Categories",
    icon: LiaMoneyCheckAltSolid,
    moduleName: UserModuleNameTypes.EXPENSE_CATEGORIES,
    path: "expense-categories",
  },
  {
    label: "Dashboad",
    icon: LiaMoneyCheckAltSolid,
    moduleName: UserModuleNameTypes.EXPENSE_CATEGORIES,
    path: "finance-dashboard",
  },
  {
    label: "Accounts",
    icon: PiBankLight,
    moduleName: UserModuleNameTypes.ACCOUNTS,
    path: "accounts",
  },
  {
    label: "Expenses",
    icon: GiMoneyStack,
    moduleName: UserModuleNameTypes.EXPENSES,
    path: "expenses",
  },
  {
    label: "Transactions",
    moduleName: UserModuleNameTypes.TRANSACTIONS,
    icon: FaMoneyBillTransfer,
    path: "transactions",
  },
  {
    label: "Upcomeing Payments",
    icon: FaCoins,
    moduleName: UserModuleNameTypes.UPCOMEING_PAYMENTS,
    path: "upcomeing-payments",
  },
  {
    label: "Coupons",
    icon: RiCoupon4Line,
    moduleName: UserModuleNameTypes.COUPONS,
    path: "coupon",
  },

];
